import { render, staticRenderFns } from "./xzbj.vue?vue&type=template&id=8ef512f0&scoped=true&"
import script from "./xzbj.vue?vue&type=script&lang=js&"
export * from "./xzbj.vue?vue&type=script&lang=js&"
import style0 from "./xzbj.vue?vue&type=style&index=0&id=8ef512f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef512f0",
  null
  
)

export default component.exports